import CTAButton from '../../components/CTAButton/CTAButton';
import TmdbAttribution from '../../components/TmdbAttribution/TmdbAttribution';
import styles from './About.module.css';

function About() {
    return (
        <main className={styles.page}>
            <div className={`container ${styles.inner}`}>
                <h1 className={styles.title}>About <span className={styles.gold}>Aluvo</span></h1>
                <p className={styles.lead}>
                    Aluvo is a social watchlist platform built for people who are serious about what they watch
                    — and want to prove it.
                </p>

                <section className={styles.section}>
                    <h2>Our Mission</h2>
                    <p>
                        We believe watching is more than passive consumption. It's culture, conversation, and community.
                        Aluvo is built to make the experience social, rewarding, and verifiable.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2>How it works</h2>
                    <ul className={styles.list}>
                        <li>📋 <strong>Track</strong> — Save movies and shows to your personal watchlist.</li>
                        <li>🌐 <strong>Share</strong> — Let friends follow your journey and discover through you.</li>
                        <li>🧠 <strong>Prove</strong> — Take the challenge to verify you watched.</li>
                        <li>🪙 <strong>Collect</strong> — Earn unique coin badges for every verified watch.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>The Team</h2>
                    <p>
                        Aluvo is built by a small team of film enthusiasts and product builders who got tired of
                        saying "I watched that" with nothing to show for it.
                    </p>
                </section>

                <section className={styles.section} id="credits" aria-labelledby="credits-title">
                    <h2 id="credits-title">Credits</h2>
                    <p>Movie and TV information and posters come from The Movie Database (TMDB).</p>
                    <TmdbAttribution variant="full" />
                </section>

                <div className={styles.cta}>
                    <CTAButton variant="gold" size="lg" href="#download" icon="📱">
                        Get the App
                    </CTAButton>
                </div>
            </div>
        </main>
    );
}

export default About;
